import React from 'react';
import { Field as FieldInner } from 'formik';
import { Input } from 'sa-ui';
import { injectIntl } from 'react-intl';
import messages from '../appMessages';

/* eslint-disable react/jsx-no-bind */
const Field = props => (
  <FieldInner name={props.name}>
    {({ field, form, ...rest }) => {
      const hasError = form.touched[field.name] && form.errors[field.name];
      const isValid = form.touched[field.name] && !form.errors[field.name];
      const value = field.value === 'undefined' ? '' : field.value;

      function getInvalidFeedback() {
        if (!hasError) return null;
        const error = form.errors[field.name];
        if (messages[error]) {
          return props.intl.formatMessage(messages[error]);
        }
        return error;
      }

      const invalidFeedback = getInvalidFeedback();
      return (
        <props.component
          {...field}
          {...props}
          error={hasError}
          value={value}
          valid={isValid}
          invalidFeedback={invalidFeedback}
          helperText={props.helperText}
        />
      );
    }}
  </FieldInner>
);

Field.defaultProps = {
  component: Input,
};

export default injectIntl(Field);
